import { getApiBaseUrl } from '../helpers/config';
import { handleErrorResponse, parseSuccessResponse } from '../helpers/responseUtils';


export const signupForUpdates = async (emailAddress: string): Promise<any> => {

  const API_BASE_URL = getApiBaseUrl();
  
  const response = await fetch(`${API_BASE_URL}/api/signup`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ emailAddress })
  });

  if (!response.ok) {
    await handleErrorResponse(response);
  }

  return await parseSuccessResponse(response);
};